import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ConsumedRestsState } from '../reducers/consumedrest.reducer';

export const consumedrestState: any = createFeatureSelector<ConsumedRestsState>('consumedrest');

export const consumedProviderTable = createSelector(consumedrestState, (state: any) => state.consumedProviderTable);

export const consumedProvider = createSelector(consumedrestState, (state: any) => state.consumedProvider);

export const consumedComponent = createSelector(consumedrestState, (state: any) => state.consumedComponent);

export const consumedApiBatch = createSelector(consumedrestState, (state: any) => state.consumedApiBatch);

export const consumedApi = createSelector(consumedrestState, (state: any) => state.consumedApi);

export const consumedProviderAutosuggest = createSelector(
  consumedrestState,
  (state: any) => state.providerAutosuggestResults
);

export const consumedProviderAdvanceSearch = createSelector(
  consumedrestState,
  (state: any) => state.providerAdvanceSearchtResults
);

export const consumedAPIByProvider = createSelector(consumedrestState, (state: any) => state.consumedAPIByProvider);

export const consumedComponentAutosuggest = createSelector(
  consumedrestState,
  (state: any) => state.componentAutosuggestResults
);

export const consumedComponentAdvanceSearch = createSelector(
  consumedrestState,
  (state: any) => state.componentAdvanceSearchRsults
);

export const providerCreateState = createSelector(consumedrestState, (state: any) => state.providerCreateState);

export const componentCreateState = createSelector(consumedrestState, (state: any) => state.componentCreateState);

export const apiBatchCreateState = createSelector(consumedrestState, (state: any) => state.apiBatchCreateState);

export const consumedApiAutosuggest = createSelector(consumedrestState, (state: any) => state.apiAutosuggestResults);

export const apiAdvanceSearchResults = createSelector(consumedrestState, (state: any) => state.apiAdvanceSearchResults);

export const deletedComponent = createSelector(consumedrestState, (state: any) => state.deletedComponent);

export const deletedProvider = createSelector(consumedrestState, (state: any) => state.deletedProvider);

export const deletedApi = createSelector(consumedrestState, (state: any) => state.deletedApi);

export const consumedComponentTable = createSelector(consumedrestState, (state: any) => state.consumedComponentTable);

export const consumedApiTable = createSelector(consumedrestState, (state: any) => state.consumedApiTable);

export const consumedRestOrders = createSelector(consumedrestState, (state: any) => state.consumedRestOrders);

export const consumedComponentByProvider = createSelector(
  consumedrestState,
  (state: any) => state.consumedComponentByProvider
);

export const consumedApiByComponent = createSelector(consumedrestState, (state: any) => state.consumedAPIByComponent);

export const newlyConsumedApiTable = createSelector(consumedrestState, (state: any) => state.newlyConsumedApiTable);
